module.exports = __webpack_public_path__ + "static/scale-model-of-wistariahurst-in-springfield-massachusetts-2167d0625a102f909aab093fb5d4b2fc.png";